/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { UtilityIcon } from './../SVGIcon';
import styles from '../../styles';

const toastColor = (props) => {
  switch (props.theme) {
    case 'success': {
      return '#04864b';
    }
    case 'failure': {
      return '#c23934';
    }
    default: {
      return '#04864b';
    }
  }
}

const Wrapper = styled.div`
  position: absolute;
  width: 100%;
  left: 0;
  top: 2rem;
  z-index: 50;

`;

const Bar = styled.div`
  width: 90%;
  max-width: 42rem;
  min-width: 30rem;
  margin: 0 auto;

  color: white;
  background-color: ${toastColor};

  border-radius: .25rem;
  padding: .75rem 1.5rem;
  display: flex;
  justify-content: space-between;
`;


class Toast extends React.Component {
  static propTypes = {
    onClose: PropTypes.func,
    children: PropTypes.node
  }


  render() {
    const { theme, text, children, onClose }= this.props;

    return (
      <Wrapper>
        <Bar theme={theme}>
          { theme === 'success' && <UtilityIcon icon='success' fill='#FFFFFF' />}
          { theme === 'failure' && <UtilityIcon icon='error' fill='#FFFFFF' />}
          {text}
          {children}
        <UtilityIcon icon='close' onClick={onClose} fill='#FFFFFF'/>
        </Bar>
      </Wrapper>
    );
  }
}

export default Toast;
